export const pageMeta = {
  "home": {
    "title": {
      "de": "All Around-Agentur - Weros Webdynamics",
      "en": "All-Around Agency - Weros Webdynamics"
    },
    "description": {
      "de": "Weros Webdynamics entwickelt Konzepte, Content-Strukturen und Workflows f\u00fcr Creator, Projekte, Marken und Teams, die sichtbar bleiben und echte Resonanz aufbauen m\u00f6chten.",
      "en": "Weros Webdynamics shapes concepts, content structures, and workflows for creators, projects, brands, and teams that want to stay visible and build real resonance."
    },
    "keywords": {
      "de": [
        "weros webdynamics",
        "pr\u00e4senz mit zugkraft",
        "digitale pr\u00e4senz",
        "content-strategie",
        "content workflows",
        "sichtbarkeit",
        "resonanz",
        "wiedererkennung",
        "creator und teams"
      ],
      "en": [
        "weros webdynamics",
        "presence with pull",
        "digital presence",
        "content strategy",
        "content workflows",
        "visibility",
        "resonance",
        "recognition",
        "creators and teams"
      ]
    },
    "canonical": "https://www.weros-webdynamics.com/",
    "pageContext": "home",
    "ogType": "website",
    "ogImage": "https://www.weros-webdynamics.com/assets/visuell/artdig30.png",
    "ogImageWidth": 1200,
    "ogImageHeight": 675
  },
  "webdesign": {
    "title": {
      "de": "Professionelles Webdesign f\u00fcr Ihr Unternehmen - Weros Webdynamics",
      "en": "Professional Web Design for your business - Weros Webdynamics"
    },
    "description": {
      "de": "Weros Webdynamics \u2013 Webdesign mit klarer Struktur, digitaler Markenpositionierung und pr\u00e4zisen KI-Strategien. Zukunftssichere Websites, starke Markenf\u00fchrung, messbare Ergebnisse.",
      "en": "Weros Webdynamics creates web design with clear structure, digital brand positioning and precise AI strategies for future-proof websites, strong brand guidance and measurable results."
    },
    "keywords": {
      "de": [
        "weros webdynamics",
        "webdesign agentur",
        "webagentur",
        "digitale markenpositionierung",
        "moderne websites",
        "ui ux",
        "conversion optimierung",
        "seo",
        "ki strategie",
        "markenentwicklung"
      ],
      "en": [
        "weros webdynamics",
        "web design agency",
        "web agency",
        "digital brand positioning",
        "modern websites",
        "ui ux",
        "conversion optimization",
        "seo",
        "ai strategy",
        "brand development"
      ]
    },
    "canonical": "https://www.weros-webdynamics.com/webdesign",
    "pageContext": "webdesign",
    "ogType": "website",
    "ogImage": "https://www.weros-webdynamics.com/assets/visuell/artdig30.png",
    "ogImageWidth": 1200,
    "ogImageHeight": 675
  },
  "digital-brand-positioning": {
    "title": {
      "de": "Digital Brand Positioning mit KI - Weros Webdynamics",
      "en": "Digital Brand Positioning with AI - Weros Webdynamics"
    },
    "description": {
      "de": "Weros Webdynamics \u2013 Digital Brand Positioning mit KI: klare Markenpositionierung, intelligente Content-Strategien, systematische Content-Planung und KI-gest\u00fctzte Suchoptimierung f\u00fcr starke, sichtbare Marken.",
      "en": "Weros Webdynamics delivers Digital Brand Positioning with AI: clear positioning, intelligent content strategies, systematic content planning and AI-supported search optimization for strong, visible brands."
    },
    "keywords": {
      "de": [
        "weros webdynamics",
        "digital brand positioning",
        "digitale markenpositionierung",
        "ki marketing",
        "ki content strategie",
        "content planung",
        "content creation",
        "ki suchoptimierung",
        "seo",
        "markenaufbau",
        "markenstrategie"
      ],
      "en": [
        "weros webdynamics",
        "digital brand positioning",
        "brand positioning",
        "ai marketing",
        "ai content strategy",
        "content planning",
        "content creation",
        "ai search optimization",
        "seo",
        "brand building",
        "brand strategy"
      ]
    },
    "canonical": "https://www.weros-webdynamics.com/digital-brand-positioning",
    "pageContext": "digital-brand-positioning",
    "ogType": "website",
    "ogImage": "https://www.weros-webdynamics.com/assets/visuell/artdig30.png",
    "ogImageWidth": 1200,
    "ogImageHeight": 675
  },
  "systems": {
    "title": {
      "de": "Intelligente KI-Systeme f\u00fcr Unternehmen - Weros Webdynamics",
      "en": "Intelligent AI Systems for businesses - Weros Webdynamics"
    },
    "description": {
      "de": "Weros Webdynamics \u2013 intelligente, effiziente KI-gest\u00fctzte Systeme f\u00fcr moderne Unternehmen. Automatisierung, modulare Architekturen und robuste digitale Prozesse f\u00fcr nachhaltige Performance.",
      "en": "Weros Webdynamics builds intelligent, efficient AI-supported systems for modern businesses, combining automation, modular architectures and robust digital processes for sustainable performance."
    },
    "keywords": {
      "de": [
        "weros webdynamics",
        "ki systeme",
        "intelligente systeme",
        "automatisierung",
        "digitale prozesse",
        "workflow automatisierung",
        "systemarchitektur",
        "modulare systeme",
        "effiziente digitale l\u00f6sungen"
      ],
      "en": [
        "weros webdynamics",
        "ai systems",
        "intelligent systems",
        "automation",
        "digital processes",
        "workflow automation",
        "system architecture",
        "modular systems",
        "efficient digital solutions"
      ]
    },
    "canonical": "https://www.weros-webdynamics.com/systems",
    "pageContext": "systems",
    "ogType": "website",
    "ogImage": "https://www.weros-webdynamics.com/assets/visuell/artdig30.png",
    "ogImageWidth": 1200,
    "ogImageHeight": 675
  },
  "ai-presence-check": {
    "title": {
      "de": "Live Website-Check f\u00fcr Ihre Online-Pr\u00e4senz - Weros Webdynamics",
      "en": "Live Website Check for your online presence - Weros Webdynamics"
    },
    "description": {
      "de": "Weros Webdynamics \u2013 Live Website-Check f\u00fcr Ihre aktuelle Internetpr\u00e4senz: Analyse von Website, Content, Struktur, Marke und Sichtbarkeit. Pr\u00e4zise Handlungsempfehlungen auf Basis moderner Website-Analyse.",
      "en": "Weros Webdynamics Live Website Check analyzes your current online presence, including website, content, structure, brand and visibility, and provides precise recommendations based on modern website analysis."
    },
    "keywords": {
      "de": [
        "weros webdynamics",
        "live website-check",
        "website analyse",
        "digitale pr\u00e4senz pr\u00fcfen",
        "content analyse",
        "seo check",
        "geo check",
        "markenwirkung analyse",
        "weboptimierung"
      ],
      "en": [
        "weros webdynamics",
        "live website check",
        "website analysis",
        "check digital presence",
        "content analysis",
        "seo check",
        "geo check",
        "brand impact analysis",
        "web optimization"
      ]
    },
    "canonical": "https://index.weros-webdynamics.com/",
    "pageContext": "ai-presence-check",
    "ogType": "website",
    "ogImage": "https://www.weros-webdynamics.com/assets/visuell/artdig30.png",
    "ogImageWidth": 1200,
    "ogImageHeight": 675
  },
  "legal": {
    "title": {
      "de": "Rechtliche Informationen (Impressum, Datenschutz, AGB, AVV, SLA) - Weros Webdynamics",
      "en": "Legal Information (Imprint, Privacy Policy, Terms, DPA, SLA) - Weros Webdynamics"
    },
    "description": {
      "de": "Rechtliche Informationen von Weros Webdynamics: Impressum, Datenschutzerkl\u00e4rung, AGB, AVV und SLA.",
      "en": "Legal information from Weros Webdynamics: imprint, privacy policy, terms, DPA and SLA."
    },
    "keywords": {
      "de": [
        "weros webdynamics",
        "rechtliche informationen",
        "impressum",
        "datenschutzerkl\u00e4rung",
        "agb",
        "avv",
        "sla",
        "data policy"
      ],
      "en": [
        "weros webdynamics",
        "legal information",
        "imprint",
        "privacy policy",
        "terms",
        "dpa",
        "sla",
        "data policy"
      ]
    },
    "canonical": "https://www.weros-webdynamics.com/legal",
    "pageContext": "legal-impressum",
    "ogType": "website",
    "ogImage": "https://www.weros-webdynamics.com/assets/visuell/artdig30.png",
    "ogImageWidth": 1200,
    "ogImageHeight": 675
  },
  "legal-impressum": {
    "title": {
      "de": "Rechtliche Informationen (Impressum, Datenschutz, AGB, AVV, SLA) - Weros Webdynamics",
      "en": "Legal Information (Imprint, Privacy Policy, Terms, DPA, SLA) - Weros Webdynamics"
    },
    "description": {
      "de": "Rechtliche Informationen von Weros Webdynamics: Impressum, Datenschutzerkl\u00e4rung, AGB, AVV und SLA.",
      "en": "Legal information from Weros Webdynamics: imprint, privacy policy, terms, DPA and SLA."
    },
    "keywords": {
      "de": [
        "weros webdynamics",
        "rechtliche informationen",
        "impressum",
        "datenschutzerkl\u00e4rung",
        "agb",
        "avv",
        "sla",
        "data policy"
      ],
      "en": [
        "weros webdynamics",
        "legal information",
        "imprint",
        "privacy policy",
        "terms",
        "dpa",
        "sla",
        "data policy"
      ]
    },
    "canonical": "https://www.weros-webdynamics.com/legal",
    "pageContext": "legal-impressum",
    "ogType": "website",
    "ogImage": "https://www.weros-webdynamics.com/assets/visuell/artdig30.png",
    "ogImageWidth": 1200,
    "ogImageHeight": 675
  },
  "services": {
    "title": {
      "de": "Alle Services - Weros Webdynamics",
      "en": "All Services - Weros Webdynamics"
    },
    "description": {
      "de": "\u00dcberblick \u00fcber die Services von Weros Webdynamics: Website-Navigator, Lead Engine, Prozessoptimierung und Web Applications.",
      "en": "Overview of Weros Webdynamics services: Website Navigator, Lead Engine, process optimization and Web Applications."
    },
    "keywords": {
      "de": [
        "weros webdynamics",
        "services",
        "leistungen",
        "website-navigator",
        "lead engine",
        "prozessoptimierung",
        "web applications"
      ],
      "en": [
        "weros webdynamics",
        "services",
        "offerings",
        "website navigator",
        "lead engine",
        "process optimization",
        "web applications"
      ]
    },
    "canonical": "https://www.weros-webdynamics.com/services/",
    "pageContext": "services",
    "ogType": "website",
    "ogImage": "https://www.weros-webdynamics.com/assets/visuell/artdig30.png",
    "ogImageWidth": 1200,
    "ogImageHeight": 675
  },
  "tour": {
    "title": {
      "de": "Unsere Leistungen - Weros Webdynamics",
      "en": "Our Services - Weros Webdynamics"
    },
    "description": {
      "de": "Filmische Tour durch die Leistungsgebiete von Weros Webdynamics mit ausklappbaren Infos zu den einzelnen Bestandteilen.",
      "en": "Cinematic tour through the service areas of Weros Webdynamics with expandable information about each part."
    },
    "keywords": {
      "de": [
        "weros webdynamics",
        "leistungen",
        "webdesign",
        "digitale markenpositionierung",
        "ki systeme",
        "services"
      ],
      "en": [
        "weros webdynamics",
        "services",
        "web design",
        "digital brand positioning",
        "ai systems",
        "service tour"
      ]
    },
    "canonical": "https://www.weros-webdynamics.com/services/tour",
    "pageContext": "tour",
    "ogType": "website",
    "ogImage": "https://www.weros-webdynamics.com/assets/visuell/artdig30.png",
    "ogImageWidth": 1200,
    "ogImageHeight": 675
  },
  "lead-engine": {
    "title": {
      "de": "Lead-Engine | Lead Engine - Weros Webdynamics",
      "en": "Lead Engine - Weros Webdynamics"
    },
    "description": {
      "de": "Lead-Engine / Lead Engine f\u00fcr automatisierte Lead-Generierung, Prospecting, Outreach und Conversion.",
      "en": "Lead Engine for automated lead generation, prospecting, outreach and conversion."
    },
    "keywords": {
      "de": [
        "lead-engine",
        "lead engine",
        "lead-generierung",
        "prospecting",
        "outreach",
        "weros webdynamics"
      ],
      "en": [
        "lead engine",
        "lead generation",
        "prospecting",
        "outreach",
        "conversion",
        "weros webdynamics"
      ]
    },
    "canonical": "https://www.weros-webdynamics.com/services/lead-engine",
    "pageContext": "lead-engine",
    "ogType": "website",
    "ogImage": "https://www.weros-webdynamics.com/assets/visuell/artdig30.png",
    "ogImageWidth": 1200,
    "ogImageHeight": 675
  },
  "website-navigator": {
    "title": {
      "de": "Website-Navigator | Website Navigator - Weros Webdynamics",
      "en": "Website Navigator - Weros Webdynamics"
    },
    "description": {
      "de": "Website-Navigator / Website Navigator als Leistung von Weros Webdynamics.",
      "en": "Website Navigator as a service from Weros Webdynamics."
    },
    "keywords": {
      "de": [
        "website-navigator",
        "Website Navigator",
        "ki-assistent",
        "weros webdynamics"
      ],
      "en": [
        "website navigator",
        "website assistant",
        "ai assistant",
        "weros webdynamics"
      ]
    },
    "canonical": "https://www.weros-webdynamics.com/services/website-navigator",
    "pageContext": "website-navigator",
    "ogType": "website",
    "ogImage": "https://www.weros-webdynamics.com/assets/visuell/artdig30.png",
    "ogImageWidth": 1200,
    "ogImageHeight": 675
  },
  "phone-assistance-system": {
    "title": {
      "de": "Telefon-Assistenzsystem | Phone Assistance System - Weros Webdynamics",
      "en": "Phone Assistance System - Weros Webdynamics"
    },
    "description": {
      "de": "Telefon-Assistenzsystem / Phone Assistance System mit intelligenter Mailbox, KI-Telefonassistent und strukturiertem Admin-Board.",
      "en": "Phone Assistance System with intelligent mailbox, AI phone assistant and structured admin board."
    },
    "keywords": {
      "de": [
        "telefon-assistenzsystem",
        "phone assistance system",
        "intelligente mailbox",
        "ki-telefonassistent",
        "weros webdynamics"
      ],
      "en": [
        "phone assistance system",
        "intelligent mailbox",
        "ai phone assistant",
        "admin board",
        "weros webdynamics"
      ]
    },
    "canonical": "https://www.weros-webdynamics.com/services/phone-assistance-system",
    "pageContext": "phone-assistance-system",
    "ogType": "website",
    "ogImage": "https://www.weros-webdynamics.com/assets/visuell/artdig30.png",
    "ogImageWidth": 1200,
    "ogImageHeight": 675
  },
  "workshops": {
    "title": {
      "de": "Workshops & Schulungen | Workshops & Training - Weros Webdynamics",
      "en": "Workshops & Training - Weros Webdynamics"
    },
    "description": {
      "de": "Workshops & Schulungen / Workshops & Training f\u00fcr digitale Tools, KI-gest\u00fctzte Arbeitsweisen und effiziente Unternehmensprozesse.",
      "en": "Workshops and training for digital tools, AI-supported workflows and efficient business processes."
    },
    "keywords": {
      "de": [
        "workshops",
        "schulungen",
        "training",
        "ki-workshops",
        "digitale tools",
        "prozessschulung",
        "weros webdynamics"
      ],
      "en": [
        "workshops",
        "training",
        "ai workshops",
        "digital tools",
        "process training",
        "business workflows",
        "weros webdynamics"
      ]
    },
    "canonical": "https://www.weros-webdynamics.com/services/workshops",
    "pageContext": "workshops",
    "ogType": "website",
    "ogImage": "https://www.weros-webdynamics.com/assets/visuell/artdig30.png",
    "ogImageWidth": 1200,
    "ogImageHeight": 675
  },
  "process-optimization": {
    "title": {
      "de": "Interne Prozessoptimierung | Internal Process Optimization - Weros Webdynamics",
      "en": "Internal Process Optimization - Weros Webdynamics"
    },
    "description": {
      "de": "Interne Prozessoptimierung / Internal Process Optimization durch vernetzte Daten, Dokumente, Automatisierung und transparente Assistenzsysteme.",
      "en": "Internal Process Optimization through connected data, documents, automation and transparent assistance systems."
    },
    "keywords": {
      "de": [
        "interne prozessoptimierung",
        "internal process optimization",
        "datenaggregation",
        "dokumentenprozesse",
        "automationssystem",
        "weros webdynamics"
      ],
      "en": [
        "internal process optimization",
        "process optimization",
        "data aggregation",
        "document processes",
        "automation system",
        "weros webdynamics"
      ]
    },
    "canonical": "https://www.weros-webdynamics.com/services/process-optimization",
    "pageContext": "process-optimization",
    "ogType": "website",
    "ogImage": "https://www.weros-webdynamics.com/assets/visuell/artdig30.png",
    "ogImageWidth": 1200,
    "ogImageHeight": 675
  },
  "web-applications": {
    "title": {
      "de": "Web Applications f\u00fcr digitale Gesch\u00e4ftsprozesse | Weros Webdynamics",
      "en": "Web Applications for digital business processes | Weros Webdynamics"
    },
    "description": {
      "de": "Individuelle Web Applications f\u00fcr Online Shops, Produktportale, Kundenportale, Plattformen, Buchungssysteme und strukturierte digitale Workflows.",
      "en": "Custom web applications for online shops, product portals, customer portals, platforms, booking systems and structured digital workflows."
    },
    "keywords": {
      "de": [
        "web applications",
        "web apps",
        "online shops",
        "product portals",
        "customer portals",
        "platforms",
        "booking systems",
        "digital workflows",
        "weros webdynamics"
      ],
      "en": [
        "web applications",
        "web apps",
        "online shops",
        "product portals",
        "customer portals",
        "platforms",
        "booking systems",
        "digital workflows",
        "weros webdynamics"
      ]
    },
    "canonical": "https://www.weros-webdynamics.com/services/web-applications",
    "pageContext": "web-applications",
    "ogType": "website",
    "ogImage": "https://www.weros-webdynamics.com/assets/visuell/artdig30.png",
    "ogImageWidth": 1200,
    "ogImageHeight": 675
  },
  "seo-geo": {
    "title": {
      "de": "SEO & GEO | SEO & GEO - Weros Webdynamics",
      "en": "SEO & GEO - Weros Webdynamics"
    },
    "description": {
      "de": "SEO & GEO f\u00fcr Sichtbarkeit in klassischen Suchmaschinen und KI-Suchen wie ChatGPT, Gemini, Claude und Perplexity.",
      "en": "SEO & GEO for visibility in classic search engines and AI search systems such as ChatGPT, Gemini, Claude and Perplexity."
    },
    "keywords": {
      "de": [
        "seo",
        "geo",
        "generative engine optimization",
        "suchmaschinenoptimierung",
        "ki-suche",
        "google ai mode",
        "weros webdynamics"
      ],
      "en": [
        "seo",
        "geo",
        "generative engine optimization",
        "search engine optimization",
        "ai search",
        "google ai mode",
        "weros webdynamics"
      ]
    },
    "canonical": "https://www.weros-webdynamics.com/services/seo-geo",
    "pageContext": "seo-geo",
    "ogType": "website",
    "ogImage": "https://www.weros-webdynamics.com/assets/visuell/artdig30.png",
    "ogImageWidth": 1200,
    "ogImageHeight": 675
  },
  "core-web-vitals": {
    "title": {
      "de": "Core Web Vitals optimieren (LCP/INP/CLS) | Weros Webdynamics",
      "en": "Optimize Core Web Vitals (LCP/INP/CLS) | Weros Webdynamics"
    },
    "description": {
      "de": "Core Web Vitals 2026: LCP, INP, CLS optimieren, damit Ihre Website schneller l\u00e4dt, stabil bleibt und besser konvertiert. Praxisnaher Fahrplan von Weros Webdynamics.",
      "en": "Core Web Vitals 2026: optimize LCP, INP and CLS so your website loads faster, stays stable and converts better. A practical roadmap from Weros Webdynamics."
    },
    "keywords": {
      "de": [
        "core web vitals",
        "lcp",
        "inp",
        "cls",
        "pagespeed",
        "web performance",
        "lighthouse",
        "web vitals optimierung",
        "webspeed",
        "weros webdynamics"
      ],
      "en": [
        "core web vitals",
        "lcp",
        "inp",
        "cls",
        "pagespeed",
        "web performance",
        "lighthouse",
        "web vitals optimization",
        "web speed",
        "weros webdynamics"
      ]
    },
    "canonical": "https://www.weros-webdynamics.com/web-knowledge/core-web-vitals",
    "pageContext": "core-web-vitals",
    "ogType": "article",
    "ogTitle": {
      "de": "Core Web Vitals (LCP/INP/CLS) optimieren",
      "en": "Optimize Core Web Vitals (LCP/INP/CLS)"
    },
    "ogDescription": {
      "de": "Core Web Vitals 2026: LCP, INP, CLS optimieren, damit Ihre Website schneller l\u00e4dt, stabil bleibt und besser konvertiert.",
      "en": "Core Web Vitals 2026: optimize LCP, INP and CLS so your website loads faster, stays stable and converts better."
    },
    "ogImage": "https://www.weros-webdynamics.com/assets/visuell/artdig23-1200.webp",
    "ogImageWidth": 1200,
    "ogImageHeight": 675
  },
  "geo": {
    "title": {
      "de": "Generative Engine Optimization (GEO) f\u00fcr KI-Antworten | Weros Webdynamics",
      "en": "Generative Engine Optimization (GEO) for AI answers | Weros Webdynamics"
    },
    "description": {
      "de": "GEO macht Websites sichtbar in KI-Antworten: klare Inhalte, strukturierte Daten, Trust-Signale und Off-Page-Belege. Weros Webdynamics zeigt 6 Bausteine.",
      "en": "GEO makes websites visible in AI answers through clear content, structured data, trust signals and off-page proof. Weros Webdynamics shows 6 building blocks."
    },
    "keywords": {
      "de": [
        "generative engine optimization",
        "geo",
        "ki antwortsysteme",
        "ai answer engine",
        "ai search",
        "ki sichtbarkeit",
        "strukturierte daten",
        "trust signals",
        "off-page signale",
        "weros webdynamics"
      ],
      "en": [
        "generative engine optimization",
        "geo",
        "ai answer systems",
        "ai answer engine",
        "ai search",
        "ai visibility",
        "structured data",
        "trust signals",
        "off-page signals",
        "weros webdynamics"
      ]
    },
    "canonical": "https://www.weros-webdynamics.com/web-knowledge/geo",
    "pageContext": "geo",
    "ogType": "article",
    "ogTitle": {
      "de": "Generative Engine Optimization (GEO) f\u00fcr KI-Antworten",
      "en": "Generative Engine Optimization (GEO) for AI answers"
    },
    "ogDescription": {
      "de": "GEO macht Websites sichtbar in KI-Antworten: klare Inhalte, strukturierte Daten, Trust-Signale und Off-Page-Belege.",
      "en": "GEO makes websites visible in AI answers through clear content, structured data, trust signals and off-page proof."
    },
    "ogImage": "https://www.weros-webdynamics.com/assets/visuell/artdig23-1200.webp",
    "ogImageWidth": 1200,
    "ogImageHeight": 675
  },
  "https": {
    "title": {
      "de": "HTTPS richtig aufsetzen (TLS/HSTS/Security-Header) | Weros Webdynamics",
      "en": "Set up HTTPS correctly (TLS/HSTS/Security Headers) | Weros Webdynamics"
    },
    "description": {
      "de": "HTTPS richtig aufsetzen: TLS, HSTS, Redirects, Mixed-Content vermeiden und Security-Header setzen. Leitfaden von Weros Webdynamics.",
      "en": "Set up HTTPS correctly: configure TLS, HSTS, redirects, mixed-content prevention and security headers. A guide from Weros Webdynamics."
    },
    "keywords": {
      "de": [
        "https",
        "tls",
        "ssl",
        "hsts",
        "security headers",
        "mixed content",
        "redirect",
        "zertifikat",
        "web security",
        "weros webdynamics"
      ],
      "en": [
        "https",
        "tls",
        "ssl",
        "hsts",
        "security headers",
        "mixed content",
        "redirect",
        "certificate",
        "web security",
        "weros webdynamics"
      ]
    },
    "canonical": "https://www.weros-webdynamics.com/web-knowledge/https",
    "pageContext": "https",
    "ogType": "article",
    "ogTitle": {
      "de": "HTTPS richtig aufsetzen (TLS/HSTS/Security-Header)",
      "en": "Set up HTTPS correctly (TLS/HSTS/Security Headers)"
    },
    "ogDescription": {
      "de": "HTTPS richtig aufsetzen: TLS, HSTS, Redirects, Mixed-Content vermeiden und Security-Header setzen.",
      "en": "Set up HTTPS correctly: configure TLS, HSTS, redirects, mixed-content prevention and security headers."
    },
    "ogImage": "https://www.weros-webdynamics.com/assets/visuell/artdig23-1200.webp",
    "ogImageWidth": 1200,
    "ogImageHeight": 675
  }
};
